import { Injectable } from '@angular/core';
import { ICRUDOptions } from '@phx-erp/shared';
import { BaseListService } from '../../../@core/services/base-list.service';
import { GET_PRODUCT_RESERVED_ORDERED_INFO } from '../../../data/definitions/product-definition';
import { BaseDataService } from '../../../data/services/base-data.service';
import {
    GetProductReservedOrderedInfoQuery,
    GetProductReservedOrderedInfoQueryVariables,
    ProductReservedOrderedInfo,
    ProductReservedOrderedInfoSearchInput
} from '../../../generated/generated-types';

@Injectable({
    providedIn: 'root'
})
export class ProductReservedOrderedInfoService extends BaseListService<ProductReservedOrderedInfo> {

    constructor(private baseDataService: BaseDataService) {
        super();
    }

    getItems(searchInput?: ProductReservedOrderedInfoSearchInput, options?: ICRUDOptions) {
        return this.baseDataService.query<GetProductReservedOrderedInfoQuery, GetProductReservedOrderedInfoQueryVariables>(
            GET_PRODUCT_RESERVED_ORDERED_INFO,
            { input: searchInput }
        );
    }
}
